module.exports = __webpack_public_path__ + "assets/img/text-douyin-7ea9d882.png";